import React from 'react';
import Immutable from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  FadeWrapper,
} from '../../../components';

import './style.scss';

const ParagraphSection = ({ id, entity, wide }) => {
  return (
    <div id={id} className="Section">
      {/* Start of paragraphs */}
      {
        entity.get('field_paragraphs') ? (
          <div className="node--page--paragraphs-wrapper">
            {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              return (
                <FadeWrapper key={`paragraph:${id}`}>
                  <Paragraph
                    id={id}
                    wide={wide}
                    entity={paragraph.get('entity')}
                  />
                </FadeWrapper>
              );
            })}
          </div>
        ) : null
      }
      {/* End of paragraphs */}
    </div>
  );
};

export default ParagraphSection;
